<section class="mk" [class.mk-open]="open()">
  <header class="mk-head" (click)="toggle()">
    <div class="mk-title">
      <svg class="mk-chev" [class.open]="open()" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="9 18 15 12 9 6" />
      </svg>
      <span class="mk-label">Mockups &amp; Assets</span>
      @if (loading()) {
        <span class="mk-count" role="status">Loading…</span>
      } @else {
        <span class="mk-count">{{ items().length + assetItems().length }}</span>
      }
    </div>
    <div class="mk-head-actions">
      <button class="mk-upload" type="button" (click)="onAddAsset($event)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
        Add asset
      </button>
      <button class="mk-upload" type="button" (click)="onUpload($event)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
        </svg>
        Upload
      </button>
    </div>
  </header>

  @if (open()) {
    <!-- Opens over the content below rather than pushing it down. -->
    <div class="mk-body" (scroll)="hideZoom()">
      <div class="mk-section-label">Mockups</div>
      @if (items().length) {
        <!-- Three at a time; scroll sideways for the rest. -->
        <div class="mk-grid" (scroll)="hideZoom()">
          @for (item of items(); track item.url) {
            <a
              class="mk-card"
              [href]="item.url"
              target="_blank"
              rel="noopener noreferrer"
              [title]="'Open ' + item.name"
              (mouseenter)="showZoom($event, item)"
              (mouseleave)="hideZoom()"
              (focus)="showZoom($event, item)"
              (blur)="hideZoom()"
            >
              <div class="mk-thumb">
                <img [src]="item.url" [alt]="item.name" loading="lazy" />
              </div>
              <div class="mk-foot">
                <span class="mk-name">{{ item.name }}</span>
                <svg class="mk-ext" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </div>
            </a>
          }
        </div>
      } @else {
        <div class="mk-empty">
          <div class="mk-empty-title">No mockups yet</div>
          <div class="mk-empty-sub">Upload mockups to see them here</div>
        </div>
      }

      @if (zoomedMockup(); as zoomed) {
        <!-- The hovered mockup, enlarged over its card (see zoomedMockup). -->
        <div
          class="mk-zoom"
          aria-hidden="true"
          [style.top.px]="zoomed.top"
          [style.left.px]="zoomed.left"
          [style.width.px]="zoomed.width"
          [style.height.px]="zoomed.height"
        >
          <img class="mk-zoom-image" [src]="zoomed.url" alt="" />
          <div class="mk-foot"><span class="mk-name">{{ zoomed.name }}</span></div>
        </div>
      }

      <!-- Documents beside the mockups: links or uploads, tagged copy doc / DRD / other. -->
      <div class="mk-section-label">Assets</div>
      @if (assetItems().length) {
        <div class="mk-assets">
          @for (asset of assetItems(); track asset.id) {
            <div class="mk-asset">
              <span class="mk-asset-type" [attr.data-type]="asset.assetType">{{ asset.typeLabel }}</span>
              <a class="mk-asset-link" [href]="asset.url" target="_blank" rel="noopener noreferrer" [title]="'Open ' + asset.title">
                @if (asset.source === 'upload') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
                  </svg>
                } @else {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                  </svg>
                }
                <span class="mk-asset-title">{{ asset.title }}</span>
              </a>
              <span class="mk-asset-meta">{{ asset.addedBy.name }} · {{ asset.addedAt | date: 'yyyy-MM-dd' }}</span>
              <button
                class="mk-asset-remove"
                type="button"
                [disabled]="removingAssetIds().includes(asset.id)"
                [attr.aria-label]="'Remove ' + asset.title"
                [title]="'Remove ' + asset.title"
                (click)="removeAsset.emit(asset)"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="mk-empty mk-empty-assets">
          <div class="mk-empty-title">No assets yet</div>
          <div class="mk-empty-sub">Add copy docs, the DRD or other documents as links or uploads</div>
        </div>
      }
    </div>
  }
</section>
